import { useFieldContext } from './form';
import { Label } from '../ui/Label';
import { Input } from '../ui/Input';
import { FieldInfo } from './FieldInfo';
import { useTranslation } from 'react-i18next';

interface TextFieldProps {
  label: string;
  placeholder?: string;
}

export function TextField({ label, placeholder }: TextFieldProps) {
  const { t } = useTranslation('common');

  const field = useFieldContext<string>();

  return (
    <div className="w-full">
      <Label htmlFor={label}>{label}</Label>
      <Input
        id={label}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        placeholder={placeholder ?? `${t('enter')} ${label}`}
      />

      <FieldInfo field={field} />
    </div>
  );
}
